import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  approveConsigmentOrder,
  deleteConsignmentOrder,
  getConsignmentOrders,
} from '../../../../appRedux/actions';
import {
  consignOrderConst,
  filters,
  searchFilters,
  searchInputInitialValues,
} from '../../../../constants/ConsignOrder.const';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { stringDate } from '../../../../util';
import { ListTable, ModalView, TableFilters } from '../../../uiComponents';
import { ConsignOrderModalBody } from '../ConsignOrderModal';
import { ConsignOrderStatus } from '../ConsignOrderStatus';
import { ConsignOrderTableOptions } from '../ConsignOrderTableOptions';
import { formatPrice } from '../../../../util/formatPrice';

export const ConsignOrderTable = ({ privileges, role }) => {
  const dispatch = useDispatch();
  const [modalTitle, setModalTitle] = useState(null);
  const [modalData, setModalData] = useState({});
  const { catalogId, setModal } = useCustomModal();

  useEffect(() => {
    if (!modalData) return;

    setModalTitle(
      `${consignOrderConst.header}: ${consignOrderConst.prefix}${modalData.orderNumber}`
    );
  });

  const onDelete = (id) => {
    dispatch(deleteConsignmentOrder(id));
  };

  const onApprove = (id) => {
    dispatch(approveConsigmentOrder(id));
  };

  const columns = [
    {
      title: 'Número de orden',
      sorter: true,
      dataIndex: 'orderNumber',
      key: 'orderNumber',
      render: (number, record) => (
        <Button
          type="link"
          htmlType="button"
          onClick={() => {
            setModal(record.id);
            setModalData(record);
          }}
        >
          {consignOrderConst.prefix + number}
        </Button>
      ),
    },
    {
      title: 'Proveedor',
      sorter: true,
      dataIndex: 'provider',
      key: 'provider',
      render: (provider) => provider?.name,
      path: 'provider.name',
    },
    {
      title: 'Fecha',
      key: 'arrivedAt',
      sorter: true,
      dataIndex: 'arrivedAt',
      render: (arrivedAt) => stringDate(arrivedAt),
    },
    {
      title: 'Estado',
      key: 'status',
      dataIndex: 'status',
      sorter: true,
      render: (status) => <ConsignOrderStatus status={status} />,
    },
    {
      title: 'IVA',
      key: 'tax',
      sorter: true,
      dataIndex: 'tax',
      render: (tax) => `${tax}%`,
    },
    {
      title: 'Total',
      sorter: true,
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => formatPrice(amount),
    },
    {
      title: 'Comentarios',
      key: 'comments',
      dataIndex: 'comments',
      render: (comments) => (comments ? comments : '-'),
    },
    {
      title: 'Opciones',
      key: 'actions',
      render: (_, record) =>
        record.isProductRow ? null : (
          <ConsignOrderTableOptions
            id={record.id}
            path="ordenes-de-consigna"
            action={{
              onDelete: {
                action: onDelete,
                params: [record.id],
              },
              onApprove: {
                action: onApprove,
                params: [record.id],
              },
            }}
            deleted={!!record.deleted_at}
            approved={record.approvedAt}
            privileges={privileges}
            sent={!!record.sentAt}
            status={record.status}
            finished={record.finishedAt}
            role={role}
            numberOrder={record.orderNumber}
          />
        ),
    },
  ];

  return (
    <>
      <TableFilters
        privileges={privileges}
        filters={filters}
        searchFilters={searchFilters}
        searchInputInitialValues={searchInputInitialValues}
      />
      <ListTable
        columns={columns}
        standOut={true}
        getDataFunction={getConsignmentOrders}
        privileges={privileges}
        params={{ status: null }}
      />
      <ModalView title={modalTitle} width={1600}>
        <ConsignOrderModalBody data={modalData} />
      </ModalView>
    </>
  );
};
